import { gql, TypedDocumentNode } from '@apollo/client';
import { DefaultApiResponse, DefaultArg } from '@libs/graphql';
import {
  MarketplaceAdditionalArgs,
  MarketplaceAssetType,
} from './getPopularMarketplaceAssets';

export type GetTopGrowingAssets = MarketplaceAssetType;
export type GetTopGrowingAssetsResponse = {
  getTopGrowingAssets: DefaultApiResponse<GetTopGrowingAssets[]>;
};
type GetTopGrowingAssetsArgs = MarketplaceAdditionalArgs;

export const getTopGrowingAssetsQuery: TypedDocumentNode<
  GetTopGrowingAssetsResponse,
  DefaultArg & GetTopGrowingAssetsArgs
> = gql`
  query GetTopGrowingAssets(
    $record: AssetGrowthRecord!
    $rateRecord: AssetsRateChangeRecord!
    $changeRecord: AssetsRateChangeRecord!
  ) {
    getTopGrowingAssets(record: $record) {
      code
      iconUrl
      isFavorite
      name
      rate(record: $rateRecord)
      change(record: $changeRecord)
    }
  }
`;
